/* TENDON - termin doruceni na detailu produktu.
 *
 * Datum se pocita VYHRADNE tady v prohlizeci, nikdy v Liquidu - HTML je cachovane
 * (CDN, bfcache, tab pres noc) a servrove datum by lhalo. Viz handoff
 * pending/doruceni-na-detailu-produktu.md, body 3 a 8.
 *
 * Konfigurace prichazi v JSON script tagu (plni ji shop metapole expedice.*):
 *   { cutoff: "10:00", transitDays: 1, closures: [{od,do}], today ... nikdy!,
 *     i18n: {...}, variants: {id: {state: "stock"|"made"|"out", qty, lead}} }
 *
 * Pravidla:
 *  - pracovni den = po-pa mimo ceske svatky (Velikonoce algoritmicky) a odstavky
 *  - pred cutoffem: "objednas do 10:00, odesleme dnes" + datum
 *  - po cutoffu / vikend / svatek: "odesleme <dalsi pracovni den>" + datum
 *  - +-20 min kolem cutoffu: podminena formulace bez dnes/zitra (konzervativni datum)
 *  - stav "made": jen rozsah lhuty, zadne datum; "out": nic (resi Liquid fallback)
 *  - jakakoli chyba => neutralni text (fail-safe), nikdy sebevedome spatne datum
 */
(function () {
  'use strict';

  var SOFT_ZONE_MIN = 20;

  /* ---------- cas v Praze (DST resi Intl, ne my) ---------- */
  function pragueNow() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Prague',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23', weekday: 'short'
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    return {
      y: +p.year, m: +p.month, d: +p.day,
      minutes: (+p.hour) * 60 + (+p.minute)
    };
  }

  /* ---------- kalendarni aritmetika nad "naivnim" datem ---------- */
  function toUTC(d) { return Date.UTC(d.y, d.m - 1, d.d); }
  function fromUTC(ms) {
    var t = new Date(ms);
    return { y: t.getUTCFullYear(), m: t.getUTCMonth() + 1, d: t.getUTCDate() };
  }
  function addDays(d, n) { return fromUTC(toUTC(d) + n * 86400000); }
  function dow(d) { return new Date(toUTC(d)).getUTCDay(); } // 0=ne .. 6=so
  function iso(d) {
    function z(n) { return (n < 10 ? '0' : '') + n; }
    return d.y + '-' + z(d.m) + '-' + z(d.d);
  }

  /* ---------- ceske svatky ---------- */
  function easterSunday(year) {
    // anonymni gregoriansky algoritmus
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var dd = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - dd - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return { y: year, m: month, d: day };
  }
  var FIXED = ['01-01', '05-01', '05-08', '07-05', '07-06', '09-28', '10-28', '11-17', '12-24', '12-25', '12-26'];
  function isHoliday(d) {
    function z(n) { return (n < 10 ? '0' : '') + n; }
    if (FIXED.indexOf(z(d.m) + '-' + z(d.d)) !== -1) return true;
    var es = easterSunday(d.y);
    var goodFriday = addDays(es, -2);
    var easterMonday = addDays(es, 1);
    return (d.y === goodFriday.y && d.m === goodFriday.m && d.d === goodFriday.d) ||
           (d.y === easterMonday.y && d.m === easterMonday.m && d.d === easterMonday.d);
  }
  function inClosure(d, closures) {
    var s = iso(d);
    for (var i = 0; i < (closures || []).length; i++) {
      var c = closures[i];
      if (c && c.od && c.do_ === undefined && c['do']) { /* klic "do" je v JS ok pres [] */ }
      var from = c.od || c.from;
      var to = c['do'] || c.to || from;
      if (from && s >= from && s <= to) return true;
    }
    return false;
  }
  function isBusinessDay(d, closures) {
    var w = dow(d);
    if (w === 0 || w === 6) return false;
    if (isHoliday(d)) return false;
    if (inClosure(d, closures)) return false;
    return true;
  }
  function nextBusinessDay(d, closures) {
    var x = addDays(d, 1), guard = 0;
    while (!isBusinessDay(x, closures) && guard++ < 60) x = addDays(x, 1);
    return x;
  }
  function addBusinessDays(d, n, closures) {
    var x = d;
    for (var i = 0; i < n; i++) x = nextBusinessDay(x, closures);
    return x;
  }

  /* ---------- vypocet slibu ---------- */
  function parseCutoff(s) {
    var m = /^(\d{1,2}):(\d{2})$/.exec((s || '').trim());
    if (!m) return null;
    return (+m[1]) * 60 + (+m[2]);
  }

  // Vraci {mode, shipDate, deliveryDate}; mode: today|next|soft
  function computePromise(now, cfg) {
    var cutoff = parseCutoff(cfg.cutoff);
    if (cutoff === null || !(cfg.transitDays >= 0)) throw new Error('config');
    var today = { y: now.y, m: now.m, d: now.d };
    var mode, shipDate;
    var todayBusiness = isBusinessDay(today, cfg.closures);
    if (todayBusiness && Math.abs(now.minutes - cutoff) <= SOFT_ZONE_MIN) {
      mode = 'soft';
      shipDate = nextBusinessDay(today, cfg.closures); // konzervativne
    } else if (todayBusiness && now.minutes < cutoff) {
      mode = 'today';
      shipDate = today;
    } else {
      mode = 'next';
      shipDate = nextBusinessDay(today, cfg.closures);
    }
    return { mode: mode, shipDate: shipDate, deliveryDate: addBusinessDays(shipDate, cfg.transitDays, cfg.closures) };
  }

  /* ---------- formatovani ---------- */
  function fill(t, data) {
    return String(t || '').replace(/\[(\w+)\]/g, function (_, k) { return data[k] != null ? data[k] : ''; });
  }
  function fmtDate(d, i18n) {
    var names = i18n.dayNames || [];
    return (names[dow(d)] || '') + ' ' + d.d + '. ' + d.m + '.';
  }
  function shipPhrase(res, i18n, cfg) {
    if (res.mode === 'soft') return fill(i18n.soft, { cutoff: cfg.cutoff });
    if (res.mode === 'today') return fill(i18n.today, { cutoff: cfg.cutoff });
    var names = i18n.dayNamesIn || [];
    return fill(i18n.next, { day: names[dow(res.shipDate)] || '' });
  }

  /* ---------- komponenta ---------- */
  function initSection(payloadEl) {
    var sid = payloadEl.getAttribute('data-tdn-delivery-data');
    var stockEl = document.querySelector('[data-tdn-delivery-stock="' + sid + '"]');
    var promiseEl = document.querySelector('[data-tdn-delivery-promise="' + sid + '"]');
    if (!stockEl && !promiseEl) return;
    var cfg;
    try { cfg = JSON.parse(payloadEl.textContent); } catch (e) { return; }
    var i18n = cfg.i18n || {};
    var currentVariant = String(cfg.initialVariant || '');
    var timer = null;

    function neutral() {
      if (promiseEl) promiseEl.innerHTML = '<span class="tdn-r-dlv__soft">' + (i18n.neutral || '') + '</span>';
    }

    function render() {
      try {
        var v = cfg.variants[currentVariant];
        if (!v) { if (stockEl) stockEl.hidden = true; if (promiseEl) promiseEl.hidden = true; return; }
        if (stockEl) {
          stockEl.hidden = false;
          var stockHtml = '';
          if (v.state === 'stock') {
            var label = (v.qty > 0 && v.qty <= 5) ? fill(i18n.stockLow, { n: v.qty }) : i18n.stock;
            stockHtml = '<span class="tdn-r-dlv__dot tdn-r-dlv__dot--on"></span>' + label;
          } else if (v.state === 'made') {
            stockHtml = '<span class="tdn-r-dlv__dot"></span>' + i18n.made;
          } else {
            stockHtml = '<span class="tdn-r-dlv__dot"></span>' + i18n.out;
          }
          stockEl.innerHTML = stockHtml;
        }
        if (promiseEl) {
          if (v.state === 'stock') {
            promiseEl.hidden = false;
            var res = computePromise(pragueNow(), cfg);
            promiseEl.innerHTML =
              '<span class="tdn-r-dlv__ship">' + shipPhrase(res, i18n, cfg) + '</span>' +
              '<span class="tdn-r-dlv__date">' + fill(i18n.delivery, { date: fmtDate(res.deliveryDate, i18n) }) + '</span>';
            schedule(res);
          } else if (v.state === 'made') {
            promiseEl.hidden = false;
            promiseEl.innerHTML = '<span class="tdn-r-dlv__ship">' + fill(i18n.madeLead, { range: v.lead || cfg.defaultLead }) + '</span>';
          } else {
            promiseEl.hidden = true;
          }
        }
      } catch (e) { neutral(); }
    }

    // prepocet na nejblizsi hranici (cutoff / pulnoc), zadny polling
    function schedule(res) {
      if (timer) clearTimeout(timer);
      var now = pragueNow();
      var cutoff = parseCutoff(cfg.cutoff) || 600;
      var boundaries = [cutoff - SOFT_ZONE_MIN, cutoff + SOFT_ZONE_MIN + 1, 24 * 60];
      var next = null;
      for (var i = 0; i < boundaries.length; i++) {
        if (boundaries[i] > now.minutes) { next = boundaries[i]; break; }
      }
      if (next === null) next = 24 * 60;
      var waitMs = Math.min((next - now.minutes) * 60000 + 5000, 6 * 3600000);
      timer = setTimeout(render, Math.max(waitMs, 30000));
    }

    // stale HTML pojistka: u made/out stavu overit sklad cerstvym fetch
    function refreshStock() {
      var v = cfg.variants[currentVariant];
      var age = Date.now() - (cfg.renderedAt || 0);
      var needs = !v || v.state !== 'stock' || age > 10 * 60000;
      if (!needs || !cfg.handle) return;
      fetch('/products/' + cfg.handle + '.js?_=' + Date.now())
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          p.variants.forEach(function (pv) {
            var known = cfg.variants[String(pv.id)];
            if (!known) return;
            if (!pv.available) known.state = 'out';
            else if (known.state === 'out') known.state = 'made';
          });
          render();
        })
        .catch(function () { /* offline apod. - nechavame posledni stav */ });
    }

    // Sekce, do ktere patrime — event je na document, na strance muze byt
    // vic produktovych formularu (quick view, doporuceni). Kdyz obe strany
    // sekci znaji a lisi se, event ignorujeme; jinak radeji reagujeme.
    var mySection = payloadEl.closest ? payloadEl.closest('.shopify-section') : null;
    function jeMuj(d) {
      if (!d || !d.form || !mySection || !d.form.closest) return true;
      var jeho = d.form.closest('.shopify-section');
      return !jeho || jeho === mySection;
    }

    document.addEventListener('on:variant:change', function (ev) {
      var d = ev && ev.detail;
      if (!d || !jeMuj(d)) return;
      // Zvolena kombinace voleb neodpovida zadne variante -> theme posle
      // variant: null, vyprazdni [name=id] a zablokuje tlacitko. Bez tehle
      // vetve tu zustal viset stav PREDCHOZI varianty ("Skladem — posledni
      // 4 ks" u neexistujici kombinace). Explicitni null ma prednost pred
      // pripadnym zastaralym variantId. (Nalez 24. 8. 2026.)
      if ('variant' in d && d.variant === null) {
        currentVariant = null;
        render();
        return;
      }
      var id = (d.variant && d.variant.id) || d.variantId || d.id;
      currentVariant = id ? String(id) : null;
      render();
    });
    // Po navratu z bfcache/pozadi neverit ulozenemu stavu — formular muze mit
    // jinou (nebo zadnou) variantu, nez s jakou jsme usnuli.
    function sync() {
      if (mySection) {
        var vstup = mySection.querySelector('[name="id"]');
        if (vstup) currentVariant = vstup.value ? String(vstup.value) : null;
      }
      render();
    }
    window.addEventListener('pageshow', sync);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sync();
    });

    render();
    refreshStock();
  }

  function boot() {
    document.querySelectorAll('script[data-tdn-delivery-data]').forEach(initSection);
  }
  /* export pro node testy; v prohlizeci boot */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { easterSunday: easterSunday, isHoliday: isHoliday, isBusinessDay: isBusinessDay, computePromise: computePromise, addBusinessDays: addBusinessDays };
  } else if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})();
